import { render } from "./Faq.vue?vue&type=template&id=fce458b4"
import script from "./Faq.vue?vue&type=script&setup=true&lang=js"
export * from "./Faq.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/static-pages/Faq.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fce458b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fce458b4', __exports__)) {
    api.reload('fce458b4', __exports__)
  }
  
  module.hot.accept("./Faq.vue?vue&type=template&id=fce458b4", () => {
    api.rerender('fce458b4', render)
  })

}


export default __exports__